import { Switch } from '@/components/Controls/Switch';
import { NotFound } from '@/components/Message/NotFound';
import { TFunction } from 'i18next';

type ResultFraudProps = {
  t: TFunction<undefined>;
  fraudConfirmed: boolean;
  setFraudConfirmed: () => void;
};

export const ResultFraud = ({
  t,
  fraudConfirmed,
  setFraudConfirmed,
}: ResultFraudProps) => {
  return (
    <div className="m-auto flex flex-wrap justify-center gap-6">
      <NotFound
        containerClassName="border py-2 px-4 border-gray-500 rounded-lg w-fit"
        textClassName="text-black self-center"
        iconClassName="mt-0"
        text="Suspicion de fraude"
      />
      <Switch
        containerClassName="self-center"
        leftText={t('fraudConfirmed')}
        checked={fraudConfirmed}
        onChange={setFraudConfirmed}
      />
    </div>
  );
};
